import React from "react";
import "./getStartedSection.css";
import { useNavigate } from "react-router-dom";

const GetStartedSection = () => {
  const navigate = useNavigate();

  const handleGetsStarted = () => {
    navigate("/allproducts");
  };
  return (
    <div className="getStarted_sectionOneCont">
      {/* <div className="getStarted_sectionOne_gen">
        <div className="get_startedHeader">
          Call <span className="get_startedSub">for Support</span>
        </div>
        <div className="getStarted_para">
          SWADAA Express is dedicated to combating drug abuse and crime, but we
          need your help. Government and individual support is crucial for
          expanding our reach, enhancing programs, and implementing
          interventions for a safer society. <br /> Government Support,
          Individual and Community Support
        </div>
        <div className="getStarted_para">
          Together, We Can Make a Difference Join us in fighting drug abuse and
          crime to build a safer, healthier society for all.
        </div>

        <div
          // href="https://api.whatsapp.com/send?phone=+2348033477608&text=I%20am%20reaching%20out%20to%20explore%20your%20business%20offering."
          // target="_blank"
          className="getStarted_btn"
          style={{ textDecoration: "none" }}
          onClick={() => {
            navigate("/contact");
          }}
        >
          Lets Get Started
        </div>
      </div> */}
    </div>
  );
};

export default GetStartedSection;
